import axios from 'axios';
import backendURLs from '@/misc/backendURLs';

export default (payload) => {
  return axios
    .post(backendURLs.creatorRequest, payload)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
